import Typography from '@components/std-components/Typography'
import { Link } from '@material-ui/core'
import { useObserver } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function QuantityChangeMessage({
  isQuantityUpdated,
  sortAgain
}): JSX.Element {
  return useObserver(function useHook() {
    const { t } = useTranslation()
    const [showSortMessage, setShowSortMessage] = React.useState(false)
    React.useEffect(() => {
      setShowSortMessage(true)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isQuantityUpdated])

    return (
      <div>
        {showSortMessage && (
          <Typography variant='subHeading1'>
            {t('common.sortQuantityMsg', 'You have made a change to the quantities ')}
            <Link onClick={sortAgain} underline='always'>
              {t('common.sortAgain', 'Sort Again')}
            </Link>
          </Typography>
        )}
      </div>
    )
  })
}
